import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200 || status === 201) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface updateCountryType {
    id: string,
    name: string,
    services: Record<string, boolean>
}

export const updateCountry = {
    browser: {
        params: (params: updateCountryType): ParamsFetchType<updateCountryType> => {
            return {
                type: MethodType.PATCH,
                url: '/api-web/admin/update-country',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PATCH,
        urlBrowser: '/api-web/admin/update-country',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<updateCountryType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        return {
            url: `${params.API_URL}/geolocation/country-config/${params.API_UNIVERSE}`,
            passToBackend: true,
            method: MethodType.PATCH,
            body: params.req.body,
        };
    }
};
